<template>
  <wp-items-view
    content-type="kb-articles"
    content-type-singular="kb-article"
    content-name="Knowledge Base Articles"
    content-name-singular="Knowledge Base Article"
  />
</template>

<script>
import WpItemsView from '@/views/wp-item/wp-items-view/WpItemsView.vue'

export default {
  components: {
    WpItemsView,
  },
}
</script>

<style scoped>

</style>
